export default __webpack_public_path__ + "static/media/LPG.06c10ab7.svg";